import { render, staticRenderFns } from "./noticeBoard.vue?vue&type=template&id=eb7cd26a&scoped=true&"
import script from "./noticeBoard.vue?vue&type=script&lang=js&"
export * from "./noticeBoard.vue?vue&type=script&lang=js&"
import style0 from "./noticeBoard.vue?vue&type=style&index=0&id=eb7cd26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7cd26a",
  null
  
)

export default component.exports